import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

export const URL_SHIFTS = `${URL_RETAILER_SCOPED}/shifts`
export const URL_CSV_HISTORY = `${URL_SHIFTS}/csv-history`
export const URL_SHIFTS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/shifts`
export const URL_CSV_HISTORY_PARTNER_SCOPED = `${URL_SHIFTS_PARTNER_SCOPED}/csv-history`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<
  'shifts' | 'csvHistory' | 'shiftsPartnerScoped' | 'csvHistoryPartnerScoped'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  shifts: URL_SHIFTS,
  csvHistory: URL_CSV_HISTORY,
  shiftsPartnerScoped: URL_SHIFTS_PARTNER_SCOPED,
  csvHistoryPartnerScoped: URL_CSV_HISTORY_PARTNER_SCOPED,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
